import { useTranslation } from 'react-i18next';

import { DrowdownMenuItem } from 'src/Components/NavBar/DrowdownMenuItem';

const LANGUAGES = [
  { code: 'fr', labelKey: 'navbar.languageMenu.french', fallback: 'Français', alt: 'French flag' },
  { code: 'en', labelKey: 'navbar.languageMenu.english', fallback: 'Anglais', alt: 'English flag' },
] as const;

/**
 * The language choices on their own, so they can live either in the dedicated header
 * menu (desktop) or inside the avatar menu (mobile, where header space is scarce).
 */
const LanguageMenuItems = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language.toLowerCase().split('-')[0];

  return (
    <>
      {LANGUAGES.map(({ code, labelKey, fallback, alt }) => (
        <DrowdownMenuItem
          key={code}
          icon={
            <img
              src={`/images/flags/${code}.svg`}
              alt={alt}
              width="16"
              height="16"
              style={{ marginRight: '8px' }}
            />
          }
          label={t(labelKey, fallback)}
          selected={currentLanguage === code}
          onClick={() => {
            i18n.changeLanguage(code);
          }}
        />
      ))}
    </>
  );
};

export default LanguageMenuItems;
